// src/routes/agenciesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Agencies from '../pages/agencies/Agencies';
import CreateAgency from '../pages/agencies/CreateAgency';
import EditAgency from '../pages/agencies/EditAgency';
import AgencySection from '../pages/agencies/AgencySection';
import ProtectedRoute from '../components/global/ProtectedRoute';

const agenciesRoutes = (
    <>
        {/* Agency Section */}
        <Route
            path="/agencies/section"
            element={
                <ProtectedRoute requiredPermission="viewAny-agency-section">
                    <AgencySection />
                </ProtectedRoute>
            }
        />

        {/* Agencies List */}
        <Route
            path="/agencies"
            element={
                <ProtectedRoute requiredPermission="viewAny-agency">
                    <Agencies />
                </ProtectedRoute>
            }
        />

        {/* Create Agency */}
        <Route
            path="/agencies/create"
            element={
                <ProtectedRoute requiredPermission="create-agency">
                    <CreateAgency />
                </ProtectedRoute>
            }
        />

        {/* Edit Agency */}
        <Route
            path="/agencies/:id/edit"
            element={
                <ProtectedRoute requiredPermission="update-agency">
                    <EditAgency />
                </ProtectedRoute>
            }
        />
    </>
);

export default agenciesRoutes;
